module.exports = __webpack_public_path__ + "img/logo.4063c859.png";